import { SvgIcon } from "@mui/material";

export default function CloseModalIcon({ ...restProps }) {
  return (
    <SvgIcon
      {...restProps}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L13 13M13 1L1 13L13 1Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
